import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "footer" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "h3 w-100 text-center" }, " Sledujte nás na sociálních sítích ", -1)
const _hoisted_6 = { class: "m-0 ms-auto me-auto list-inline" }
const _hoisted_7 = { class: "list-inline-item" }
const _hoisted_8 = {
  href: "https://www.facebook.com/profile.php?id=61555397120486&sk=about",
  title: "Facebook"
}
const _hoisted_9 = { class: "list-inline-item" }
const _hoisted_10 = {
  href: "https://www.youtube.com/channel/UCdXgAprvLzHHiCwObnwz7pg",
  title: "Youtube"
}
const _hoisted_11 = { class: "list-inline-item" }
const _hoisted_12 = {
  href: "https://instagram.com/kometa_synchro?igshid=YmMyMTA2M2Y=",
  title: "Instagram"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "w-100 text-center mt-3 mb-3" }, "© 2025 Kometa", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navigation = _resolveComponent("navigation")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_navigation),
    _createVNode(_component_router_view),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("section", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("a", _hoisted_8, [
                  _createVNode(_component_icon, {
                    type: "fab",
                    "icon-name": "facebook"
                  })
                ])
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("a", _hoisted_10, [
                  _createVNode(_component_icon, {
                    type: "fab",
                    "icon-name": "youtube"
                  })
                ])
              ]),
              _createElementVNode("li", _hoisted_11, [
                _createElementVNode("a", _hoisted_12, [
                  _createVNode(_component_icon, {
                    type: "fab",
                    "icon-name": "instagram"
                  })
                ])
              ])
            ]),
            _hoisted_13
          ])
        ])
      ])
    ])
  ], 64))
}